function Contact() {
  return (
    <div>
      <h1>Welcome to the Contact Page</h1>
      <p>If I can figure it out this will have a email form</p>
      <p>But for now email me at <a href="mailto:xavierstephenson123@gmail.com">xavierstephenson123@gmail.com</a></p>
      <p>And follow me on <a href="https://www.linkedin.com/in/xavierstephenson/" target="_blank" rel="noreferrer">Linkedin!</a></p>
    </div>
  );
}

export default Contact;